export interface Status {
  id?: number;
  state?: string;
  order?: number;
  name?: string;
  class?: string;
  color?: string;
  background?: string;
  default?: number;
  environmentId?: number;
}
